// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProcessingTierDto } from './IProcessingTierDto';
import {
    IProcessingTierDtoFromJSON,
    IProcessingTierDtoFromJSONTyped,
    IProcessingTierDtoToJSON,
    IProcessingTierDtoToJSONTyped,
} from './IProcessingTierDto';

/**
 * 
 * @export
 * @interface IProcessingRuleDto
 */
export interface IProcessingRuleDto {
    /**
     * 
     * @type {number}
     * @memberof IProcessingRuleDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessingRuleDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IProcessingRuleDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessingRuleDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IProcessingRuleDto
     */
    organization_type?: IProcessingRuleDtoOrganizationTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessingRuleDto
     */
    editable?: boolean;
    /**
     * 
     * @type {Array<IProcessingTierDto>}
     * @memberof IProcessingRuleDto
     */
    tiers?: Array<IProcessingTierDto>;
    /**
     * 
     * @type {number}
     * @memberof IProcessingRuleDto
     */
    enrollment_matrix_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessingRuleDto
     */
    processing_rule_type?: IProcessingRuleDtoProcessingRuleTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessingRuleDto
     */
    is_health_plan_processing_rule?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IProcessingRuleDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
* @export
* @enum {string}
*/
export enum IProcessingRuleDtoProcessingRuleTypeEnum {
    DEFAULT = 'DEFAULT',
    EMBEDDED_ONLY = 'EMBEDDED_ONLY',
    AGGREGATE_ONLY = 'AGGREGATE_ONLY',
    COMBINED = 'COMBINED'
}


/**
 * Check if a given object implements the IProcessingRuleDto interface.
 */
export function instanceOfIProcessingRuleDto(value: object): value is IProcessingRuleDto {
    return true;
}

export function IProcessingRuleDtoFromJSON(json: any): IProcessingRuleDto {
    return IProcessingRuleDtoFromJSONTyped(json, false);
}

export function IProcessingRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessingRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'editable': json['editable'] == null ? undefined : json['editable'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(IProcessingTierDtoFromJSON)),
        'enrollment_matrix_id': json['enrollment_matrix_id'] == null ? undefined : json['enrollment_matrix_id'],
        'processing_rule_type': json['processing_rule_type'] == null ? undefined : json['processing_rule_type'],
        'is_health_plan_processing_rule': json['is_health_plan_processing_rule'] == null ? undefined : json['is_health_plan_processing_rule'],
    };
}

export function IProcessingRuleDtoToJSON(json: any): IProcessingRuleDto {
    return IProcessingRuleDtoToJSONTyped(json, false);
}

export function IProcessingRuleDtoToJSONTyped(value?: IProcessingRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'organization_type': value['organization_type'],
        'editable': value['editable'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(IProcessingTierDtoToJSON)),
        'enrollment_matrix_id': value['enrollment_matrix_id'],
        'processing_rule_type': value['processing_rule_type'],
        'is_health_plan_processing_rule': value['is_health_plan_processing_rule'],
    };
}

